<template>
  <div class="d-flex flex-column align-items-center justify-content-center" style="min-height: 100vh">
    <div v-if="error" class="text-danger text-center px-4">
      <i class="ri-error-warning-line fs-1 mb-2 d-block"></i>
      <p>{{ error }}</p>
      <small class="text-muted">You can close this window.</small>
    </div>
    <div v-else class="text-center px-4">
      <div class="spinner-border text-dark mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted">Completing Threads authorization...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThreadsOAuthCallback",

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    // console.log("[Threads OAuth Callback] URL params:", Object.fromEntries(params.entries()));

    if (error) {
      const msg = errorDescription
        ? decodeURIComponent(errorDescription.replace(/\+/g, " "))
        : error;
      // console.error("[Threads OAuth Callback] Auth error:", error, msg);
      this.error = msg;
      if (window.opener) {
        window.opener.postMessage(
          { type: "THREADS_AUTH_ERROR", error, errorDescription: msg },
          window.location.origin
        );
      }
      return;
    }

    if (code && window.opener) {
      // console.log("[Threads OAuth Callback] Code received:", code);
      // console.log("[Threads OAuth Callback] Sending code to parent window...");
      window.opener.postMessage(
        { type: "THREADS_AUTH_CODE", code },
        window.location.origin
      );
      // console.log("[Threads OAuth Callback] Message sent. Closing popup.");
      window.close();
    } else if (!window.opener) {
      // console.warn("[Threads OAuth Callback] No opener found. Was this opened as a popup?");
      this.error = "No parent window found. Please close this window and try again.";
    } else {
      // console.warn("[Threads OAuth Callback] No code in URL.");
      this.error = "No authorization code received.";
    }
  },

  data() {
    return {
      error: null,
    };
  },
};
</script>
